module.exports = __webpack_public_path__ + "img/pdf-icon.7fa74df.svg?v=1791296779994";